/**
 * @generated SignedSource<<08a04747f06d11547d5f9aa7711c9384>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type personalizedCollectionsTracking_item$data = {
  readonly browseUrl: string | null;
  readonly categoryCode: string | null;
  readonly contemporaryTrackingString: string;
  readonly localizedPdpUrl: string | null;
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "personalizedCollectionsTracking_item";
};
export type personalizedCollectionsTracking_item$key = {
  readonly " $data"?: personalizedCollectionsTracking_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"personalizedCollectionsTracking_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "personalizedCollectionsTracking_item"
};

(node as any).hash = "38525111f9132b8d6812f63b22401c1a";

export default node;
